function waitForElement(selector, callback, count = 1, countLimit = 30) {
  const checkWaitingElementInterval = setInterval(() => {
    if (document.querySelectorAll(selector).length >= count) {
      clearInterval(checkWaitingElementInterval)
      callback();
    } else {
      countLimit--
    }

    if (!countLimit) {
      clearInterval(checkWaitingElementInterval)
      if (document.querySelectorAll(selector).length > 0) callback();
    }
  }, 1000);
}

function handleNavigation(nav) {
  const direction = nav.classList.contains('ldt-cp-compare-nav--next') ? 'next' : 'prev';
  const scrollBy = document.querySelector('.ldt-cp-compare-list-wrapper th[scope="col"]').clientWidth;
  const scrollLeft = document.querySelector('.ldt-cp-compare-list-wrapper').scrollLeft


  if (direction === 'next') {
    nav.previousElementSibling.removeAttribute('disabled');
    nav.toggleAttribute('disabled', scrollLeft + document.querySelector('.ldt-cp-compare-list-wrapper').clientWidth + scrollBy >= document.querySelector('.ldt-cp-compare-list-wrapper').scrollWidth);
  } else {
    nav.nextElementSibling.removeAttribute('disabled');
    nav.toggleAttribute('disabled', (scrollLeft - scrollBy) <= 0);
  }

  document.querySelector('.ldt-cp-compare-list-wrapper').scrollBy({
    left: scrollBy * (direction === 'next' ? 1 : -1),
    behavior: 'smooth'
  })
}

function initNavigations () {
  const scrollBy = document.querySelector('.ldt-cp-compare-list-wrapper th[scope="col"]').clientWidth;
  const scrollLeft = document.querySelector('.ldt-cp-compare-list-wrapper').scrollLeft

  document.querySelector('.ldt-cp-compare-nav--next')
    .toggleAttribute('disabled', scrollLeft + document.querySelector('.ldt-cp-compare-list-wrapper').clientWidth + scrollBy >= document.querySelector('.ldt-cp-compare-list-wrapper').scrollWidth);
}

function appendArrowElements () {
  const div = document.createElement("div")
  div.classList.add('ldt-cp-compare-nav-wrapper')

  div.innerHTML = `
    <button
      type="button"
      class="button button--action-circle ldt-cp-compare-nav ldt-cp-compare-nav--prev"
      aria-label="Previous"
      disabled
    >
      <svg width="12" height="12" viewBox="0 0 12 12" aria-hidden="true">
        <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#icon-arrow-left"></use>
      </svg>
    </button>
    <button
      type="button"
      class="button button--action-circle ldt-cp-compare-nav ldt-cp-compare-nav--next"
      aria-label="Next"
    >
      <svg width="12" height="12" viewBox="0 0 12 12" aria-hidden="true">
        <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#icon-arrow-right"></use>
      </svg>
    </button>
  `
  document.querySelector('.ldt-cp-compare-list-wrapper').append(div)

  document.querySelectorAll('.ldt-cp-compare-nav').forEach(el => el.addEventListener('click', () => {
    handleNavigation(el)
  }))

  // initNavigations()
}

document.addEventListener('click', e => {
  // close popup on remove-all event
  if (e.target.closest('.ldt-cp-confirm-modal [title="Yes"]')) {
    document.querySelector('.ldt-cp-toolbar-actions-close').click()
  }
})

document.addEventListener('DOMContentLoaded', e => {
  if (!document.querySelector('#ldt-app-proxy-root')) return;

  waitForElement('.ldt-cp-compare-list-wrapper', () => {
    appendArrowElements()
  })
})
